import Main from '../../../shared/types/enums/main';
import Rail from '../../../shared/classes/rail';
import Slider from '../../../shared/classes/slider';
import TMain from '../templates/main';
import cornerObservable from '../../../shared/api/corners/cornerObservable';
import useComplete from '../../../shared/components/utils/hooks/useComplete';
import { Observer } from 'rxjs';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useState } from 'react';
import { clearFocus } from '../../../shared/store/slices/focus.slice';

function Corner() {
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);
  const dispatch = useAppDispatch();

  const [complete, setComplete] = useComplete();
  const [rails, setRails] = useState<Rail[]>([]);
  const [sliders, setSliders] = useState<Slider[]>([]);

  useEffect(() => {
    if (complete) return;
    dispatch(clearFocus());
    const id = (currentParams as { id: string }).id;
    const title = (currentParams as { title: string }).title;
    if (id && !complete) {
      const cornerObserver: Observer<{
        data: Slider[] | Rail[];
        type: number;
      }> = {
        next: (val) => {
          if (val.type === Main.SLIDERS) {
            setSliders(val.data as Slider[]);
          } else if (val.type === Main.RAILS) {
            setRails(val.data as Rail[]);
          }
        },
        error: () => {
          console.error('Error recovering corners');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };
      cornerObservable(id, title).subscribe(
        cornerObserver as Partial<Observer<unknown>>
      );
    }
  }, [complete, currentParams]);

  return (
    <TMain
      complete={complete}
      hideBackground={true}
      rails={rails}
      sliders={sliders}
      startsInMenu={false}
      startsInSlider={true}
    />
  );
}

export default Corner;
